<template>
  <button class="poi-button" @click="navigate">{{ text }}</button>
</template>

<script>
export default {
  name: "PoiButton",
  props: {
    location: String,
    text: String,
  },
  methods: {
    navigate: function () {
      this.$emit("navigate", this.location);
    },
  },
};
</script>

<style scoped></style>
